import { ErrorState, IconTitle, InformationBlock, Loading } from '@dec/shared';
import { t } from 'i18next';
import { Calendar2, CurrencyExchange, FileEarmarkText } from 'react-bootstrap-icons';

import { useTaxReturn } from '../hooks/useTaxReturn';

interface TaxReturnCardProps {
  id: string;
}

export function TaxReturnCard({ id }: TaxReturnCardProps) {
  const { data, isLoading, error } = useTaxReturn(id);

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorState />;
  }

  return (
    <div className="card h-100">
      <div className="card-header bg-soft text-primary">
        <IconTitle
          title={data?.formVersion?.form.name ?? ''}
          icon={FileEarmarkText}
          subtitle={t('dashboard.taxReturns')}
        />
      </div>
      <div className="card-body py-4 px-4">
        <InformationBlock
          title={t('config.taxReturn')}
          value={data?.taxReturnNumber}
          icon={FileEarmarkText}
        />
        <InformationBlock
          title={t('common.label.period')}
          value={String(data?.period)}
          icon={Calendar2}
        />
        <InformationBlock
          title={t('taxpayer-payments.label.amountTaxReturn')}
          value={Number(data?.taxReturnTotal).toLocaleString()}
          icon={CurrencyExchange}
        />
      </div>
    </div>
  );
}
